import { Stack, Group, Box } from '@mantine/core';
import { AfaModal, AfaButton, AfaDropzone,AfaTextarea } from '../../ui';
import ApiService from '../../../utils/ApiService';
import { useState } from 'react';
import { notifications } from '@mantine/notifications';
import { convertToBase64 } from '../../../utils/Utils';
import { useNavigate } from 'react-router-dom';

interface UploadDocumentacioTramesaModalProps {
  apiService: ApiService;
  opened: boolean;
  onClose: () => void;
  tramesaId: any;
  tramesaState: any;
  entityId : any
}

export function UploadDocumentacioTramesaModal({ apiService, opened, onClose, tramesaId, tramesaState, entityId}: UploadDocumentacioTramesaModalProps) {

  const [getComentarisValue, setComentarisValue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<Array<{ file: File; name: string; type: 'pdf' | 'doc' | 'xls' | 'ppt' | 'png' | 'jpg' | 'other' }>>([]);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setIsSubmitting(true);
    e.preventDefault();
    const docs = await Promise.all(
      uploadedFiles.map(async (item) => {
        const base64 = await convertToBase64(item.file);
        return {
          title: '00_' + item.name,
          content: base64.split(",")[1],
        };
      })
    );

    let fase  = "Validació i Anàlisi"; 
    
    const dataForm = {
      state: "Tramès",
      EntitatId : entityId,
      comments: getComentarisValue,
      docs,
      fase
    };

    //console.log(dataForm)

    apiService.UpdateTramesa(tramesaId, dataForm)
      .then((result: any) => {
        if (result.statusText === "OK") {
          notifications.show({
            title: "Tramesa actualitzada",
            message: "La tramesa s'ha actualitzat correctament",
            color: "teal",
          });
          //navigate('/trameses/consultar');

          const data = result.data;
          
          //console.log(data)
          
          navigate(`/trameses/editar/${data.itemId}`, {
            state: {
              fromUploadDocs: true,
              pdf: data.document?.fileContents ?? null,
              codi: data.itemGuid
            }
          });
          
        } else {
          notifications.show({
            title: "Error",
            message: result.message || "S'ha produït un error inesperat.",
            color: "red",
          });
        }
      })
      .catch((error: any) => {
        setIsSubmitting(false);
        notifications.show({
          title: "Error",
          message: error.message || "S'ha produït un error inesperat.",
          color: "red",
        });
      })
  };

  const handleClose = () => {
    onClose();
  };

  const getFileExtension = (filename: string): string | null => {
    const cleanName = filename.trim();

    const lastDotIndex = cleanName.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === cleanName.length - 1) {
      return null;
    }

    return cleanName.substring(lastDotIndex + 1).toLowerCase();
  };

  return (
    <AfaModal
      opened={opened}
      onClose={handleClose}
      title="Pujar documentació"
      size="lg"
      centered
    >
      <form onSubmit={handleSubmit}>
        <Stack mt="sm" gap="md">
          <Box mt="xs">
            <AfaDropzone
              onDrop={(files) => {
                const newFiles = files.map(file => {
                  //const extension = file.name.split('.').pop()?.toLowerCase();
                  const extension = getFileExtension(file.name);
                  let type: 'pdf' | 'doc' | 'xls' | 'ppt' | 'png' | 'jpg' | 'other' = 'other';

                  if (extension === 'pdf') type = 'pdf';
                  else if (extension === 'doc' || extension === 'docx') type = 'doc';
                  else if (extension === 'xls' || extension === 'xlsx') type = 'xls';
                  else if (extension === 'ppt' || extension === 'pptx') type = 'ppt';
                  else if (extension === 'png') type = 'png';
                  else if (extension === 'jpg' || extension === 'jpeg') type = 'jpg';

                  return { file, name: file.name, type };
                });

                setUploadedFiles(prevFiles => [...prevFiles, ...newFiles]);
              }}
              uploadedFiles={uploadedFiles}
              onDeleteFile={(_, index) => {
                const newFiles = uploadedFiles.filter((_, i) => i !== index);
                setUploadedFiles(newFiles);
              }}
            />
          </Box>

            <AfaTextarea
              id="comentaris"
              name="comentaris"
              label="Comentaris"
              placeholder="Escriure aquí"
              autosize
              minRows={3}
              maxRows={6}
              value={getComentarisValue}
              onChange={(e) => setComentarisValue(e.target.value)}
              />
            <div style={{ flex: 1 }}></div>

          <Group justify="flex-end">
            <AfaButton
              id="btn-cancelar-ara"
              variant="filled"
              // color="red"
              type="submit"
              loading={isSubmitting}
            >
              Enviar
            </AfaButton>
          </Group>
        </Stack>

      </form>
    </AfaModal>
  );
}
